import * as React from 'react';
import { Text, TextTag, TokenTextAppearance } from '../text';
import { styled } from '../theme-provider';
import { Container, ContainerGutter, ContainerWrap } from '../container';
import { NotificationMessage } from '../notification-message';
import { InputAppearance } from '../helpers/input';
import { getCommonProps } from '../helpers/common-props';
const StyledFieldset = styled.fieldset.withConfig({ displayName: "StyledFieldset", componentId: "sc-16gvfsk" }) `border:none;padding:0;margin:0;min-width:0;>:nth-last-child(2){margin-bottom:${(props) => props.theme.size.static350};}`;
export const Fieldset = (props) => {
    const { children, legend, required, appearance, message } = props;
    const commonProps = getCommonProps(props);
    const errorShouldBeVisible = Boolean(appearance === InputAppearance.Error && message);
    return (React.createElement(StyledFieldset, Object.assign({}, commonProps),
        legend && (React.createElement(Text, { appearance: TokenTextAppearance.copy200, bold: true, staticSize: true, tag: TextTag.legend },
            legend,
            required && '*')),
        React.createElement(NotificationMessage, { appearance: appearance }, errorShouldBeVisible ? message : undefined),
        React.createElement(Container, { gutter: ContainerGutter.static350, wrap: ContainerWrap.always }, children)));
};
